import API from '../../../constants/api';

export const FETCH_CHAPTER_LIST_REQUEST = '@@chapter/FETCH_CHAPTER_LIST_REQUEST';
export const FETCH_CHAPTER_LIST_FAILURE = '@@chapter/FETCH_CHAPTER_LIST_FAILURE';
export const FETCH_CHAPTER_LIST_SUCCESS = '@@chapter/FETCH_CHAPTER_LIST_SUCCESS';

export const CREATE_CHAPTER_REQUEST = '@@chapter/CREATE_CHAPTER_REQUEST';
export const CREATE_CHAPTER_FAILURE = '@@chapter/CREATE_CHAPTER_FAILURE';
export const CREATE_CHAPTER_SUCCESS = '@@chapter/CREATE_CHAPTER_SUCCESS';

export const CLEAR_CHAPTER_STATE = '@@chapter/CLEAR_CHAPTER_STATE';

export const fetchPagesOfChapter = (api = API.SERVICES.SBS.CHAPTERS, page, size, sortCol, sortOrder, filters) => ({
    type: FETCH_CHAPTER_LIST_REQUEST,
    api: `${api}?page=${page}&size=${size}&sortCol=${sortCol}&sortOrder=${sortOrder}&filter=${encodeURIComponent(JSON.stringify(filters))}`,
    page,
    size,
    sortCol,
    sortOrder,
});

export const createChapterRequest = (chapter, isUpdate, successCallback, failureCallBack) => ({
    type: CREATE_CHAPTER_REQUEST,
    api: API.SBS.CHAPTER.PAGES,
    chapter,
    isUpdate,
    successCallback,
    failureCallBack,
});

export const clearChapterState = () => ({
    type: CLEAR_CHAPTER_STATE,
});
